/* import { imprimirServicoNovo } from "../utils";
import adapter from "./adapter";
import layout from "./layout";

async function imprimir(dados) {
  const viaCliente = dados["121"];
  const viaEstabelecimento = dados["122"];

  let comandos = [];

  if (viaCliente) {
    const { comandos: comandosViaCliente } = layout(adapter(viaCliente));
    comandos = [...comandos, ...comandosViaCliente];
  }

  if (viaEstabelecimento) {
    const { comandos: comandosViaEstabelecimento } = layout(
      adapter(viaEstabelecimento),
    );
    comandos = [...comandos, ...comandosViaEstabelecimento];
  }

  const response = await imprimirServicoNovo("1", "comprovante-tef", comandos);
  return response.data;
}

export default imprimir; */

import {
  imprimirServicoNovo,
} from '../utils';
import { imprimirComprovanteTef } from 'modulo-gerencial-erp-pacotes-impressora-termica'

async function imprimir(dados) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 12, query);
  }

  const dados = await buscarDadosImpressao(id, 12);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(id, 'troco', comandos);
  return response.data; */

   return await imprimirComprovanteTef({id: 1, dados, chamarServicoImpressoraTermica: imprimirServicoNovo, query: ''})
}

export default imprimir;
